import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

export default makeStyles((theme: Theme) => ({
  linkBase: {
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
  linkDisabled: {
    cursor: 'default',
    color: theme.palette.darkGrey[15],
  },
  default: {
    color: theme.palette.darkGrey.main,
  },
  blue: {
    color: theme.palette.info.main,
  },
  red: {
    color: theme.palette.secondary.main,
  },
  withUnderline: {
    textDecoration: 'underline',
  },
  boldText: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
  },
}));
